import { Layout, Row, Col, Typography, Space, Grid } from "antd";
import {
  FacebookOutlined,
  InstagramOutlined,
  MailOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

import logo from "../../../assets/images/Logo-Rifas-Gran-Familia.png";
import "./FooterPage.css";

const { useBreakpoint } = Grid;
const { Footer } = Layout;
const { Text, Link } = Typography;

export default function FooterPage() {
  const screens = useBreakpoint();

  return (
    <Footer className="footer-start">
      <Row gutter={[16, 16]} justify="space-between">
        {screens.md && (
          <Col xs={24} md={8}>
            <Link to="/">
              <img
                src={logo}
                alt="Rifas Gran Familia GDL"
                style={{ maxHeight: "90px" }}
              />
            </Link>
          </Col>
        )}
        <Col xs={24} md={8}>
          <Space direction="vertical" size="middle">
            <Text strong>Legales</Text>
            <Link href="/privacidad" className="footer-red-link">
              Aviso de Privacidad
            </Link>
          </Space>
        </Col>
        <Col xs={24} md={8}>
          <Space direction="vertical" size="large">
            <Text strong>Redes</Text>
            <div color="black">
              <a
                href="https://www.facebook.com/share/1BzuzWbdrC/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookOutlined className="footer-icon red-color" />
              </a>
              <a
                href="https://www.instagram.com/rifasgranfamiliagdl_"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramOutlined className="footer-icon red-color" />
              </a>
              <a
                href="mailto:contacto@rifasgranfamiliagdl.com.mx"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MailOutlined className="footer-icon red-color" />
              </a>
              <a
                href="https://api.whatsapp.com/send?phone=523318415075"
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsAppOutlined className="footer-icon red-color" />
              </a>
            </div>
          </Space>
        </Col>
        <div style={{ width: "100%" }}>
          <Text>
            Copyright 2025 Rifas Gran Familia GDL. Todos los derechos
            reservados.
          </Text>
        </div>
      </Row>
    </Footer>
  );
}
